<!-- 会员日志 -->
<template>
  <div class="fuzzy-matching-box">
    <div class="fuzzy-matching-top">
      <el-row class="top-first-line the-second-line">
        <el-col :span="5">
          <el-form-item label="用户名：">
            <el-input v-model="Dform.schoolValue" placeholder=''></el-input>
          </el-form-item>
        </el-col >
        <el-col :span="5">
          <el-form-item label="状态：">
              <el-select filterable v-model="value" placeholder="--请选择--">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col >
          <el-col :span="5">
        </el-col >
          <el-col :span="5">
          </el-col >
      </el-row>
      <el-row class="top-first-line the-second-line">
        <el-col :span="5">
          <el-form-item label="登录时间：">
            <el-date-picker
                v-model="Dform.startTime"
                type="datetime"
                format="YYYY-MM-DD HH:mm:ss"
                value-format="YYYY-MM-DD HH:mm:ss"
                placeholder="选择日期时间">
            </el-date-picker>
          </el-form-item>
      </el-col >
        <el-col :span="5">
          <el-form-item label="To：">
            <el-date-picker
                
                v-model="Dform.terminalTime"
                type="datetime"
                format="YYYY-MM-DD HH:mm:ss"
                value-format="YYYY-MM-DD HH:mm:ss"
                placeholder="选择日期时间">
            </el-date-picker>
          </el-form-item>
        </el-col >
        <el-col :span="5">
        </el-col >
        <el-col :span="5">
        </el-col >
   
        <el-button type="primary" class="query-button" @click="inquiryClick">查询</el-button>
      </el-row>
    </div>
    <div class="fuzzy-matching-bottom">
      <el-row class="list">
         <el-table
         :header-cell-style="{background:'#F2F2F2',color:'#000',}"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange">
          <el-table-column
            prop="name"
            label="会员账号"
            >
          </el-table-column>
          <el-table-column
            prop="IMEIdata"
            label="昵称"
            >
          </el-table-column>
          <el-table-column
          prop="laiyuan"
          label='邮箱'
          >
          </el-table-column>
          <el-table-column
            prop="danwei"
            label="IP"
            >
          </el-table-column>
          <el-table-column
            prop="danwei"
            label="第三方"
            >
          </el-table-column>
          <el-table-column
            prop="danwei"
            label="操作时间"
            >
          </el-table-column>
          <el-table-column
            prop="danwei"
            label="操作"
            >
          </el-table-column>
        </el-table>

        <div class="block-fenye" >
          <el-pagination
              :small="small"
              :disabled="disabled"
              :background="background"
              layout="prev, pager, next, jumper"
              :total="1000"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
        </div>
      </el-row>
    </div>

  </div>
</template>

<script>
export default {
  components: {

  },
  data() {
      return {
        Dform: {
          imei: '',
          name: '',
          typeValue: '',
          started:'',
          expirationTime:'',
        },
      };
  },
  created() {

  },
  mounted() {

  },
  methods: {

  },
};
</script>
<style scoped lang="scss">
  .fuzzy-matching-box {
    padding-top: 20px;
    // overflow: hidden;
    // overflow: auto;
    width: 100%;
    height:  92%;
    background-color: #fff;
    border-radius: 8px;
    .title-top {
        padding: 20px 20px;
    }
    .fuzzy-matching-top {
    height: 120px ;
    background-color: #fff;
    border-radius: 8px;
    .top-first-line {
      // justify-content: center 
      // justify-content: space-between
      justify-content: space-around;
      /deep/ {
        .el-form-item--small .el-form-item__label {
          // background-color: red;
          font-size: 16px;
        }
        .el-select--small {
            width: 100%
        }
        .el-form-item--small .el-form-item__label {
          width: 110px;
          text-align: right;
          height: 35px;
          line-height: 35px;          
        }
        .el-input {
          width: 100%;
          height: 35px;
        }
      }
    }
    .the-second-line {
      margin-top: 15px;
      position: relative;
      .query-button {
        position: absolute;
        left: 800px;
        padding: 16px 24px;
        // top: 50%;
        // transform: translate(0,-50%);
      }
     
    }
    /deep/ {
      .el-range-editor--small.el-input__wrapper {
          height: 35px;
          line-height: 35px;  
      }
    }
  }
  .fuzzy-matching-bottom {
    height: calc(100% - 170px);
    overflow: auto;
    position: relative;
    padding: 0px 20px;
    padding-top: 10px;
    margin-top: 15px;
    background-color: #fff;
    border-radius: 8px;
    
    .top-first-line {
      height: 45px;
      line-height: 45px;
        /deep/ .tip-button {
          padding: 14px 14px;
          margin: 0px 3px;
        }
      .import-export-button {
        position: absolute;
        right: 20px;
        /deep/ .el-button--small {
          padding: 16px 24px;
          border: 1px solid #569CFF;
          color: #569CFF;
        }
      }
    }
    .list {
      position: relative;
      // margin-top: 10px;
      padding-bottom: 50px;
     .fenye {
      // float: right;
      text-align: center;
     }
      /deep/ {
        // .el-checkbox.el-checkbox--small .el-checkbox__inner {
        //   width: 18px;
        //   height: 18px;
        // }
        // .el-checkbox:last-of-type {
        //   margin-right: -1px;
        // }
        .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf {
          border: 0px;
        }
        .el-table tr {
          height: 40px;
          cursor: pointer;
          font-size: 14px;
        }
         .manipulate {
          color: red;
          margin-right:15px;
          cursor: pointer;
          user-select: none;
        }
        .confirm,.duplicate,.revise {
          color:#1677FF;
          
        }
        .el-table th.el-table__cell>.cell {
          text-align: center;
        }
        .el-table td.el-table__cell, .fuzzy-matching-box .fuzzy-matching-bottom .list[data-v-1ddf37d1] .el-table th.el-table__cell.is-leaf {
          text-align: center;
        }
      }
      .block-fenye {
        // float: right;
        position: absolute;
        bottom: 0px;
        left: 50%;
        transform: translate(-50%,0);
        
      }
    }
  }
}
</style>
